import { render, staticRenderFns } from "./PatrimonyBadge.vue?vue&type=template&id=3d385f5e&scoped=true&"
import script from "./PatrimonyBadge.vue?vue&type=script&lang=js&"
export * from "./PatrimonyBadge.vue?vue&type=script&lang=js&"
import style0 from "./PatrimonyBadge.vue?vue&type=style&index=0&id=3d385f5e&scoped=true&lang=css&"
import style1 from "./PatrimonyBadge.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d385f5e",
  null
  
)

export default component.exports